import { Box, BoxProps, styled, Typography } from "@mui/material";
import { colors, transitions } from "../../styles/theme";
import { convertToBreakpoints, getFluidsByKeys } from "../../utils/fuilds";

export type ContainerProps = { $disableHover?: boolean } & BoxProps;
export const Container = styled(Box, {
  shouldForwardProp: (prop: string) => !prop.includes("$"),
})<ContainerProps>(({ theme, $disableHover }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  userSelect: "none",
  svg: {
    color: colors.text.v3,
    "&.left, &.right": {
      width: "auto",
      fontSize: "inherit",
    },
    "&.left": {
      ...convertToBreakpoints(theme, {
        xs: { marginRight: "5px" },
        md: { marginRight: "10px" },
        xxl: { marginRight: "15px" },
      }),
    },
    "&.right": {
      ...convertToBreakpoints(theme, {
        xs: { marginLeft: "5px" },
        md: { marginLeft: "10px" },
        xxl: { marginLeft: "15px" },
      }),
    },
  },
  "*": {
    transition: transitions.join("color"),
  },
  ...(!$disableHover && {
    "&:hover *": {
      color: colors.text.v4,
    },
  }),
}));

export const Text = styled(Typography)<ContainerProps>(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  textTransform: "uppercase",
  letterSpacing: "5px",
  transition: transitions.join("color"),
  width: "auto",
  [theme.breakpoints.down("md")]: {
    letterSpacing: "2px",
  },
}));
